import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

const UIContext = createContext(null);

export function UIProvider({ children }) {
  const [cartOpen, setCartOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [mobileNavOpen, setMobileNavOpen] = useState(false);

  // Lock body scroll when any overlay is open
  useEffect(() => {
    const open = cartOpen || searchOpen || mobileNavOpen;
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [cartOpen, searchOpen, mobileNavOpen]);

  const value = useMemo(
    () => ({ cartOpen, setCartOpen, searchOpen, setSearchOpen, mobileNavOpen, setMobileNavOpen }),
    [cartOpen, searchOpen, mobileNavOpen]
  );

  return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export const useUI = () => useContext(UIContext);
